import NavigationButton from '@/components/navigation/navigation-button';
import { ButtonProps } from '@cmpsr/components';
import { ReactNode } from 'react';

interface AuthNavigationButtonProps extends ButtonProps {
  to: string;
  children: ReactNode;
  active?: boolean;
}

const AuthNavigationButton = ({ to, children, active = false, ...rest }: AuthNavigationButtonProps) => (
  <NavigationButton
    to={to}
    width="100%"
    variant="ghost"
    backgroundColor={active ? 'white' : 'transparent'}
    textColor="#2C4364"
    fontSize="0.875rem"
    fontWeight="400"
    lineHeight="1.4"
    borderRadius="26px"
    boxShadow={active ? '0px 26px 60px 0px rgba(141, 155, 170, 0.15)' : '0px 15px 60px 0px rgba(141, 155, 170, 0.05)'}
    _hover={{
      backgroundColor: active ? 'white' : 'transparent',
    }}
    _active={{
      backgroundColor: active ? 'white' : 'transparent',
    }}
    _disabled={{
      backgroundColor: active ? 'white' : 'transparent',
      opacity: 1,
    }}
    {...rest}
  >
    {children}
  </NavigationButton>
);

export default AuthNavigationButton;
